import { range } from "lodash"
import { Sprites } from "../../../utils/Sprites"
import { MakeVideoAtlases } from "../MakeVideoAssets"
import { MakeVideoSprite } from "../MakeVideoTypes"

export class MakeVideoCheeringCrowdSprite implements MakeVideoSprite {
    private static CHEER = "CHEER"

    active: boolean
    private sprite: Phaser.Sprite

    constructor(game: Phaser.Game, group: Phaser.Group, x: number, y: number, debug: boolean) {
        this.sprite = Sprites.add(game, MakeVideoAtlases.CROWD_JUMPING, {debug, group, x, y})
        this.sprite.animations.add(MakeVideoCheeringCrowdSprite.CHEER, range(6), 20, true)
        this.visible = false
        this.active = true
    }

    destroy = () => {
        this.sprite.destroy(true)
        this.active = false
    }

    cheer = () => {
        if (!this.visible) {
            this.visible = true
        }
        this.sprite.play(MakeVideoCheeringCrowdSprite.CHEER)
    }

    set visible(visible: boolean) {
        this.sprite.visible = visible
    }
}